import { ComponentKind, TableColumn, InputOutputTables, TableGlideType, MutatingScreenKind } from "../description";
import { SerializedComponent } from "../../components/SerializedApp";
import { ComponentBuilder, ComponentDescriptor, ComponentConfiguratorContext } from ".";
import { defaultFieldComponent, BaseFieldComponentHandler } from "./base-field";
import { getDocURL } from "../../docUrl";
import {
    DateTimeFieldComponentDescription,
    pastAndOrFuturePropertyHandler,
    propertyNamePropertyHandler,
} from "./date-fields";
import { makeEnumProperty } from "./property-utils";
import { PastAndOrFuture } from "../../components/past-future";

const ComponentKindDateTimeField: ComponentKind = "date-time-field";

export class DateTimeFieldComponentHandler extends BaseFieldComponentHandler<DateTimeFieldComponentDescription> {
    constructor() {
        super(ComponentKindDateTimeField, "date-time");
    }

    public entryForTableColumn(
        builder: ComponentBuilder,
        desc: DateTimeFieldComponentDescription,
        { output }: InputOutputTables,
        mutatingScreenKind: MutatingScreenKind | undefined,
        _validFlag: SerializedComponent | undefined,
        outputContext: SerializedComponent
    ): SerializedComponent {
        return this.fieldEntryForTableColumn(
            builder,
            desc,
            output,
            outputContext,
            mutatingScreenKind,
            "dateTime",
            propertyNamePropertyHandler,
            "DateTimeField",
            undefined,
            "ParseUserDateTime",
            { pastAndOrFuture: builder.b.constant(pastAndOrFuturePropertyHandler.getEnum(desc)) }
        );
    }

    public getDescriptor(
        _desc: DateTimeFieldComponentDescription,
        _table: TableGlideType | undefined,
        ccc: ComponentConfiguratorContext,
        mutatingScreenKind: MutatingScreenKind | undefined
    ): ComponentDescriptor<DateTimeFieldComponentDescription> {
        return this.getFieldDescriptor(
            ccc,
            "Date Time",
            "Display and edit a date time",
            "Pickers",
            "componentDateTime",
            propertyNamePropertyHandler,
            false,
            getDocURL("dateTimeField"),
            mutatingScreenKind,
            "Time",
            [pastAndOrFuturePropertyHandler]
        );
    }

    public static defaultComponent(column: TableColumn): DateTimeFieldComponentDescription {
        return {
            ...defaultFieldComponent(column, ComponentKindDateTimeField),
            pastAndOrFuture: makeEnumProperty(PastAndOrFuture.All),
        };
    }
}
